/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStubDescriptionProps extends DivProps {}

function StubDescription(props: IStubDescriptionProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>Для завершения входа и работы с сервисом, пожалуйста, установите наше мобильное приложение.</S.MainBlock>
  );
}

export default StubDescription;
